import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  DmpParams,
  DmpService,
  PaginatedDmpSubmissionsResponse,
} from '@services/dmpSubmissionService'

export const getDmpSubmissions = createAsyncThunk<
  PaginatedDmpSubmissionsResponse,
  DmpParams
>('dmp/submissions', async (params) => {
  return await DmpService.getDmpSubmissions(params)
})